<template>
  <div class="goods">
    <div class="shopbox">
      <van-swipe
        :autoplay="3000"
        :show-indicators="false"
      >
        <van-swipe-item
          v-for="(image, index) in images"
          :key="index"
        >
          <img
            :src="image"
            class="banner"
          >
        </van-swipe-item>
      </van-swipe>
      <div class="countsale padding612">
        ￥397
      </div>
      <div class="money padding612 padding0">
        价格 ￥<span class="linethrough">199.00</span>
      </div>
      <div class="title ellipsis padding612 padding0">
        RingmiiHX  500H
      </div>
      <div class="sy-cell_between padding612 salenum">
        <div>快递：免运费</div>
        <div>月销：26</div>
      </div>
    </div>
    <div class="comment">
      <van-cell is-link :border="false">
        <template slot="title">
          <span class="custom-text">用户评价（1190）</span>
        </template>
      </van-cell>
      <div class="combox padding612">
        <div class="sy-cell">
          <img src="http://pic37.nipic.com/20140113/8800276_184927469000_2.png" class="avter">
          <div class="avter_name">
            海*薇
          </div>
        </div>
        <div class="comment-text ellipsis">
          东西很好用，而且还特别简单，很适合老年人用，不懂的问客服，客服态度也都很好，好评。
        </div>
      </div>
    </div>
    <div class="sku">
      <van-cell :border="false">
        <template slot="title">
          <span class="custom-text">产品规格</span>
        </template>
      </van-cell>
      <div class="sku-text">
        产品型号：DN201<br>
        电池容量：300mAh，持续使用长达四天<br>
        电池寿命：使用时间长达4年<br>
        待机时间：90小时，短途出行无需充电<br>
        数据传输方式：GPRS<br>
        显示屏：OLED屏幕1.3寸，夜视清晰无压力<br>
        传感器：3轴加速度传感器，小巧便捷，检测灵敏
      </div>
    </div>
    <BuyRead />
    <div class="sy-cell footer">
      <button class="add">
        加入购物车
      </button>
      <button class="buy" @click="submitOrder()">
        立即购买
      </button>
    </div>
  </div>
</template>
<script>
import BuyRead from './components/buyRead'
export default {
  name: 'Details',
  components: {
    BuyRead
  },
  data() {
    return {
      images: [
        require('../../assets/images/goods/pr/1.jpg')
      ]

    }
  },
  methods: {
    submitOrder() {
      // this.$router.push('/order/submitOrder')
    }
  }
}
</script>
<style lang="scss" scoped>
.shopbox{
    background:#fff;
    padding-bottom: 12px;
    margin-bottom: 12px;
}
.banner{
    width: 100%;
    height: 375px;
}
.countsale{
height:auto;
font-size:23px;
font-family:PingFangSC-Medium;
font-weight:500;
color:rgba(255,118,14,1);
line-height:33px;
}
.money{
    font-size:12px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:17px;
}
.title{
font-size:15px;
font-family:PingFangSC-Medium;
font-weight:500;
color:rgba(51,51,51,1);
line-height:21px;
}
.padding612{
    padding: 6px 12px;
}
.padding0{
    padding-top: 0;
}
.salenum{
font-size:13px;
font-family:PingFangSC-Regular;
font-weight:400;
color:rgba(153,153,153,1);
line-height:18px;
}
.combox{
    background: #fff;
    padding: 12px;
    margin-bottom: 12px;
}
.avter{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 3px;
}
.avter-name{
height:20px;
font-size:14px;
font-family:PingFangSC-Regular;
font-weight:400;
color:rgba(153,153,153,1);
line-height:20px;
}
.comment-text{
    font-size:14px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:20px;
    padding-top: 4px;
}
.sku{
    padding:15px;
    background:#fff;
    .custom-text{
        height:19px;
        font-size:13px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:19px;
    }
    .van-cell{
        padding-left:0;
    }
    .sku-text{
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
    }
}
.add{
    width: 50vw;
    height: 50px;
    background: url('../../assets/images/goods/bg1.png') no-repeat;
    background-size:cover;
    background-position: center center;
}
.buy{
    width: 50vw;
    height: 50px;
    background: url('../../assets/images/goods/bg2.png') no-repeat;
    background-size:cover;
    background-position: center center;
}
.footer{
    position: fixed;
    bottom: 0;
    height:40px;
    font-size:14px;
    font-family:PingFangSC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:40px;
    text-align: center;
}
</style>

